module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Cooking-pot-2e51241aa09280849f0fd27c191277e9.svg";